import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	copy: {
		id: 'business-list.list-view.key-cell.copy',
		defaultMessage: 'Copy link',
		description: 'Message indicating that the action is to copy a link',
	},
});
